import { useThemeContext } from "@/v2-ui/theme/theme.context"
import {
  FONT_SIZE_OPTIONS,
  BORDER_RADIUS_OPTIONS,
  PAGE_WIDTH_OPTIONS,
  usePageWidth,
} from "@/v2-backoffice-client/settings/settings.config"
import SettingSection from "@/v2-backoffice-client/settings/SettingSection"
import SettingOptionGroup from "@/v2-backoffice-client/settings/SettingOptionGroup"

function SettingAppearance() {
  const { theme, setTheme } = useThemeContext()
  const [pageWidth, setPageWidth] = usePageWidth()

  return (
    <SettingSection
      title="Appearance"
      description="Controls the visual density and sizing of the interface."
      preview={
        <div className="space-y-3">
          <div
            className="rounded-md border border-border overflow-hidden bg-background text-[1rem]"
            style={{ borderRadius: `${theme.radius}rem` }}
          >
            <div className="px-3 py-2 border-b border-border flex items-center gap-2">
              <div className="size-[2em] rounded-full bg-muted flex items-center justify-center text-[0.7em] font-medium shrink-0">
                JS
              </div>
              <div className="min-w-0">
                <p className="font-medium truncate leading-tight">John Smith</p>
                <p className="text-muted-foreground text-[0.85em] truncate">
                  john@example.com
                </p>
              </div>
            </div>

            <div className="px-3 py-2 space-y-1 text-[0.85em]">
              <div className="flex gap-3">
                <span className="text-muted-foreground w-14 shrink-0">
                  Status
                </span>
                <span>Active</span>
              </div>
              <div className="flex gap-3">
                <span className="text-muted-foreground w-14 shrink-0">
                  Tenant
                </span>
                <span>Acme Corp</span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {[
              {
                label: "Button",
                className:
                  "px-4 py-1.5 bg-primary text-primary-foreground text-xs font-medium",
              },
              {
                label: "Card",
                className: "px-4 py-3 border border-border bg-card text-xs",
              },
              {
                label: "Input",
                className:
                  "px-3 py-1.5 border border-input bg-background text-xs text-muted-foreground",
              },
            ].map((item) => (
              <div
                key={item.label}
                className={item.className}
                style={{ borderRadius: `${theme.radius}rem` }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      }
    >
      <div className="space-y-5">
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Font Size
          </p>
          <SettingOptionGroup<number>
            options={FONT_SIZE_OPTIONS}
            value={theme.fontSize}
            onChange={(v) => setTheme({ ...theme, fontSize: v })}
          />
        </div>

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Border Radius
          </p>
          <SettingOptionGroup<number>
            options={BORDER_RADIUS_OPTIONS}
            value={theme.radius}
            onChange={(v) => setTheme({ ...theme, radius: v })}
          />
        </div>

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Page Width
          </p>
          <SettingOptionGroup
            options={PAGE_WIDTH_OPTIONS}
            value={pageWidth}
            onChange={setPageWidth}
          />
        </div>
      </div>
    </SettingSection>
  )
}

export default SettingAppearance
